import { useEffect, useState } from 'react';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Button from '@sdk/components/ui/buttons/Button';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import gettext from '@sdk/lang/gettext';
import FieldError from '@sdk/components/forms/components/FieldError';
import Text14 from '@sdk/components/ui/typography/Text14';

import { ButtonContainer } from '@web/components/survey/ButtonContainer';

import CommentInput from '../survey/CommentInput';

import SurveyStep from './SurveyStep';

type Props = {
  comment: string;
  setComment: (comment: string) => void;
  submitStep: () => void;
  stepNumber?: number;
  stepsCount?: number;
  text?: string;
  submitLabel?: string;
  isCommentRequired?: boolean;
};

const SurveyCommentStep = ({
  comment,
  setComment,
  submitStep,
  stepNumber,
  stepsCount,
  text,
  submitLabel,
  isCommentRequired = true,
}: Props) => {
  const [hasError, setHasError] = useState(false);
  const canSubmit = comment || !isCommentRequired;

  const submit = () => {
    if (canSubmit) {
      submitStep();
    }

    setHasError(!canSubmit);
  };

  useEffect(() => {
    if (comment) {
      setHasError(false);
    }
  }, [comment]);

  return (
    <SurveyStep number={stepNumber} count={stepsCount}>
      {!!text && <Text14 themeColor={ThemeColorType.gray}>{text}</Text14>}

      <FieldError invalid={hasError} error={gettext('* Please specify the reason')} />

      <CommentInput
        hasError={hasError}
        placeholder={gettext('Type your comment...')}
        value={comment}
        onChange={({ target: { value } }): void => setComment(value)}
      />

      <ButtonContainer>
        <Button
          inactive={!canSubmit}
          buttonType={canSubmit ? ButtonType.primary : ButtonType.disabledStyle}
          onClick={submit}>
          {submitLabel || gettext('Submit')}
        </Button>
      </ButtonContainer>
    </SurveyStep>
  );
};

export default SurveyCommentStep;
